import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import {
    vxRule
} from "./utils/js/formCheck.js"
Vue.prototype.vxRule = vxRule;
import constant from "./config/constant.js"
// 将constant挂在在prototype上挂载到Vue实例上面
Vue.prototype.constant = constant;
import commonFuncs from './common/commonFuncs.js'
// 将constant挂在在prototype上挂载到Vue实例上面
Vue.prototype.commonFuncs = commonFuncs;
import qs from "qs"
Vue.prototype.qs = qs;
//格式化日期
import moment from 'moment'
Vue.prototype.$moment = moment
    //全局引入echarts
import * as echarts from 'echarts';
// 将echarts挂在到prototype的vue实例上面
Vue.prototype.echarts = echarts;
//全局引入axios
import axios from 'axios';
//注册axios组件
Vue.prototype.$http = axios;
// 引入字体
import "./assets/fonts/font.css"
//引入公共样式
import "./../static/css/comm.css"
import "./../static/css/afterComm.css"
import "./../static/css/element-ui.css"

Vue.config.productionTip = false //阻止vue在启动时生成生产提示
Vue.use(ElementUI);






new Vue({
    router,
    constant,
    store, //注入store,当键名(key)和值(value)名字一样可以这样缩写
    render: h => h(App),
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js